


// import React, { useState, useEffect } from "react";
// import {
//     getCateringOrders,
//     getCateringVendors,
//     debugAdminApi,
//     approveCateringOrder
// } from "../../../Servicefile/ordermanagementservice.jsx";
// const Vendordersdetails = () => {
//     const [showDetails, setShowDetails] = useState({});
//     const [orders, setOrders] = useState([]);
//     const [vendors, setVendors] = useState([]);
//     const [editableAmounts, setEditableAmounts] = useState({});
//     const [editMode, setEditMode] = useState({});
//     const [loading, setLoading] = useState(false);
//     const [error, setError] = useState(null);

//     // Success popup state
//     const [showSuccessPopup, setShowSuccessPopup] = useState(false);
//     const [successMessage, setSuccessMessage] = useState("");

//     // Fetch orders and vendors on component mount
//     useEffect(() => {
//         fetchOrders();
//         fetchVendors();
//         debugPermissions();
//     }, []);

//     // Add success popup auto-close
//     useEffect(() => {
//         if (showSuccessPopup) {
//             const timer = setTimeout(() => {
//                 setShowSuccessPopup(false);
//                 setSuccessMessage("");
//             }, 2000);
//             return () => clearTimeout(timer);
//         }
//     }, [showSuccessPopup]);

//     // Add this useEffect to check token validity
//     useEffect(() => {
//         const checkAuth = () => {
//             const authToken = localStorage.getItem("authToken");
//             console.log("Auth token on load:", authToken ? "Present" : "Missing");

//             // Optional: Decode token to check expiration (if it's a JWT)
//             if (authToken && authToken.split('.').length === 3) {
//                 try {
//                     const payload = JSON.parse(atob(authToken.split('.')[1]));
//                     console.log("Token payload:", payload);

//                     // Check expiration
//                     if (payload.exp) {
//                         const expirationDate = new Date(payload.exp * 1000);
//                         console.log("Token expires:", expirationDate);

//                         if (Date.now() >= payload.exp * 1000) {
//                             console.log("⚠️ Token has expired!");
//                         }
//                     }
//                 } catch (e) {
//                     console.log("Could not decode token (not a JWT)");
//                 }
//             }
//         };

//         checkAuth();
//     }, []);

//     // Add debug function
//     const debugPermissions = async () => {

//         const authToken =
//             localStorage.getItem("authToken");

//         console.log("=== DEBUG AUTH ===");

//         console.log("Token exists:", !!authToken);

//         try {

//             // 🔥 SERVICE API
//             const response =
//                 await debugAdminApi(authToken);

//             console.log(
//                 "GET /admin/all - Status:",
//                 response.status
//             );

//             console.log(
//                 "GET - Success:",
//                 response.status === 200
//             );

//         } catch (e) {

//             console.log(
//                 "GET - Error:",
//                 e.message
//             );
//         }

//         if (orders.length > 0) {

//             const sampleOrder =
//                 orders[0];

//             const orderId =
//                 sampleOrder.id ||
//                 sampleOrder.orderId;


//         }
//     };

//     // Fetch orders from API
//     const fetchOrders = async () => {

//         setLoading(true);

//         setError(null);

//         try {

//             const authToken =
//                 localStorage.getItem("authToken");

//             if (!authToken)
//                 throw new Error(
//                     "No auth token found. Please login."
//                 );



//             // 🔥 SERVICE API
//             const data =
//                 await getCateringOrders(authToken);



//             const filteredData =
//                 Array.isArray(data)
//                     ? data.filter(
//                         item =>
//                             item.adminPermision === false
//                     )
//                     : [];



//             setOrders(filteredData);

//             const initialAmounts = {};

//             const initialEditMode = {};

//             filteredData.forEach(order => {

//                 const orderId =
//                     order.id ||
//                     order.orderId;

//                 initialAmounts[orderId] = {
//                     budget:
//                         order.budget?.toString() || "",

//                     paymentAmount:
//                         order.paymentAmount?.toString() || ""
//                 };

//                 initialEditMode[orderId] = false;
//             });

//             setEditableAmounts(initialAmounts);

//             setEditMode(initialEditMode);

//             localStorage.setItem(
//                 "vendOrdersData",
//                 JSON.stringify(filteredData)
//             );

//         } catch (err) {

//             console.error(
//                 "Error fetching orders:",
//                 err
//             );

//             setError(
//                 "Failed to load orders."
//             );

//         } finally {

//             setLoading(false);
//         }
//     };

//     // Fetch vendors from new API
//     const fetchVendors = async () => {

//         try {

//             const authToken =
//                 localStorage.getItem("authToken");

//             if (!authToken) return;

//             // 🔥 SERVICE API
//             const data =
//                 await getCateringVendors(authToken);


//             const processedVendors =
//                 Array.isArray(data)
//                     ? data.map(vendor => ({
//                         id:
//                             vendor.vendorId ||
//                             vendor.id,

//                         companyName:
//                             vendor.registeredName ||
//                             vendor.companyName ||
//                             vendor.name ||
//                             "Company Name Not Available",

//                         vendorId:
//                             vendor.vendorId
//                     }))
//                     : [];

//             setVendors(processedVendors);

//         } catch (err) {

//             console.error(
//                 "Error fetching vendors:",
//                 err
//             );
//         }
//     };

//     // Handle edit button click
//     const handleEditClick = (orderId) => {
//         const order = orders.find(o => (o.id === orderId || o.orderId === orderId));

//         // Check if order is in editable state
//         if (order.adminPermision === true) {
//             setSuccessMessage("❌ Cannot edit - Order already approved");
//             setShowSuccessPopup(true);
//             return;
//         }

//         setEditMode(prev => ({
//             ...prev,
//             [orderId]: true
//         }));
//     };

//     // Handle cancel edit
//     const handleCancelEdit = (orderId) => {
//         // Reset to original values
//         const order = orders.find(o => (o.id === orderId || o.orderId === orderId));
//         setEditableAmounts(prev => ({
//             ...prev,
//             [orderId]: {
//                 budget: order.budget?.toString() || "",
//                 paymentAmount: order.paymentAmount?.toString() || ""
//             }
//         }));

//         setEditMode(prev => ({
//             ...prev,
//             [orderId]: false
//         }));
//     };

//     // Handle amount changes (only when in edit mode)
//     const handleAmountChange = (orderId, field, value) => {
//         if (!editMode[orderId]) return; // Only allow changes in edit mode

//         // Allow only numbers and decimal point
//         const regex = /^\d*\.?\d*$/;
//         if (value === "" || regex.test(value)) {
//             setEditableAmounts(prev => ({
//                 ...prev,
//                 [orderId]: {
//                     ...prev[orderId],
//                     [field]: value
//                 }
//             }));
//         }
//     };

//     // Handle save amount - FIXED WITH BETTER ERROR HANDLING
//     const handleSendApproval = async (
//         order,
//         selectedVendorIds = [],
//         assignToAll = false
//     ) => {

//         const orderId =
//             order.orderId || order.id;

//         const authToken =
//             localStorage.getItem("authToken");

//         const updatedPaymentAmount =
//             Number(
//                 editableAmounts[orderId]?.paymentAmount ||
//                 order.paymentAmount ||
//                 0
//             );

//         const bodyData = {
//             adminPermision: true,
//             paymentAmount: updatedPaymentAmount,
//             assignToAll: assignToAll,
//             vendorIds: assignToAll
//                 ? null
//                 : selectedVendorIds
//         };

//         console.log("FINAL APPROVAL BODY:", bodyData);

//         try {

//             // 🔥 SERVICE API
//             await approveCateringOrder(
//                 orderId,
//                 bodyData,
//                 authToken
//             );

//             setSuccessMessage(
//                 assignToAll
//                     ? "✅ Order approved and sent to all vendors!"
//                     : `✅ Order approved and sent to ${selectedVendorIds.length} vendor(s)!`
//             );

//             setShowSuccessPopup(true);

//             setOrders(prev =>
//                 prev.map(item =>
//                     (item.id === orderId ||
//                         item.orderId === orderId)
//                         ? {
//                             ...item,
//                             adminPermision: true
//                         }
//                         : item
//                 )
//             );

//         } catch (err) {

//             console.error("Approval Error:", err);

//             setSuccessMessage(
//                 "❌ " +
//                 (err.response?.data?.message || err.message)
//             );

//             setShowSuccessPopup(true);
//         }
//     };

//     // Format date
//     const formatDate = (dateString) => {
//         if (!dateString) return "N/A";
//         return dateString;
//     };

//     // Calculate total plates
//     const getTotalPlates = (order) => {
//         return (order.vegPlates || 0) + (order.nonVegPlates || 0) + (order.mixedPlates || 0);
//     };

//     // Format location
//     const formatLocation = (order) => {
//         const parts = [];
//         if (order.fullAddress) parts.push(order.fullAddress);
//         if (order.city) parts.push(order.city);
//         if (order.state) parts.push(order.state);
//         if (order.pincode) parts.push(order.pincode);
//         if (order.country) parts.push(order.country);
//         return parts.join(', ');
//     };

//     // Check if item is non-veg
//     const isNonVeg = (item) => {
//         if (!item || typeof item !== 'string') return false;
//         const itemLower = item.toLowerCase();
//         const nonVegKeywords = ['chicken', 'chiken', 'mutton', 'fish', 'egg', 'prawn', 'meat', 'beef', 'pork'];
//         return nonVegKeywords.some(keyword => itemLower.includes(keyword));
//     };

//     // Format add-on name for display
//     const formatAddOnName = (addOnType) => {
//         if (!addOnType) return '';
//         return addOnType
//             .split('_')
//             .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
//             .join(' ');
//     };

//     const styles = {
//         card: {
//             border: '1px solid #ccc',
//             padding: '16px',
//             margin: '16px',
//             marginTop: "25px",
//             borderRadius: '10px',
//             marginRight: "5px",
//             marginLeft: "5px",
//             background: "linear-gradient(to right, #f46b45, #eea849)"
//         },
//         header: {
//             display: 'flex',
//             justifyContent: 'space-between',
//             alignItems: 'center',
//             flexWrap: 'wrap',
//             gap: '10px'
//         },
//         orderId: { margin: 0, fontWeight: "bold" },
//         dropdownBtn: {
//             background: 'none',
//             border: 'none',
//             fontSize: '20px',
//             cursor: 'pointer',
//             color: '#333'
//         },
//         pickupBtn: {
//             background: '#28a745',
//             color: '#fff',
//             border: 'none',
//             padding: '8px 20px',
//             cursor: 'pointer',
//             borderRadius: '5px',
//             fontWeight: "bold",
//             fontSize: "16px"
//         },
//         vegBadge: {
//             backgroundColor: "#e6f7e6",
//             color: "#2e7d32",
//             padding: "2px 8px",
//             borderRadius: "12px",
//             fontSize: "11px",
//             fontWeight: "bold",
//             marginLeft: "8px",
//             display: "inline-block"
//         },
//         nonVegBadge: {
//             backgroundColor: "#ffe6e6",
//             color: "#d32f2f",
//             padding: "2px 8px",
//             borderRadius: "12px",
//             fontSize: "11px",
//             fontWeight: "bold",
//             marginLeft: "8px",
//             display: "inline-block"
//         },
//         amountDisplay: {
//             width: "150px",
//             padding: "8px 12px",
//             border: "2px solid #e0e0e0",
//             borderRadius: "6px",
//             fontSize: "16px",
//             fontWeight: "500",
//             backgroundColor: "#f8f9fa",
//             color: "#333",
//             display: "inline-block"
//         },
//         amountInput: {
//             width: "150px",
//             padding: "8px 12px",
//             border: "2px solid rgb(230 109 51)",
//             borderRadius: "6px",
//             fontSize: "16px",
//             fontWeight: "500",
//             outline: "none",
//             transition: "all 0.3s ease",
//             backgroundColor: "white"
//         },
//         editButton: {
//             backgroundColor: "#ffc107",
//             color: "#333",
//             border: "none",
//             padding: "8px 20px",
//             borderRadius: "6px",
//             cursor: "pointer",
//             fontWeight: "bold",
//             fontSize: "14px",
//             marginLeft: "10px",
//             transition: "all 0.3s ease"
//         },
//         saveButton: {
//             backgroundColor: "rgb(230 109 51)",
//             color: "white",
//             border: "none",
//             padding: "8px 20px",
//             borderRadius: "6px",
//             cursor: "pointer",
//             fontWeight: "bold",
//             fontSize: "14px",
//             marginLeft: "10px",
//             transition: "all 0.3s ease"
//         },
//         cancelButton: {
//             backgroundColor: "#6c757d",
//             color: "white",
//             border: "none",
//             padding: "8px 20px",
//             borderRadius: "6px",
//             cursor: "pointer",
//             fontWeight: "bold",
//             fontSize: "14px",
//             marginLeft: "10px",
//             transition: "all 0.3s ease"
//         }
//     };

//     if (loading) return (
//         <div style={{
//             textAlign: "center",
//             padding: "40px",
//             fontSize: "18px",
//             color: "#666"
//         }}>
//             Loading orders...
//         </div>
//     );

//     if (error) return (
//         <div style={{
//             textAlign: "center",
//             padding: "40px",
//             fontSize: "18px",
//             color: "#ff4444"
//         }}>
//             {error}
//         </div>
//     );

//     return (
//         <div style={{ position: 'relative', height: '100%' }}>
//             {/* Success Popup */}
//             {showSuccessPopup && (
//                 <div style={{
//                     position: 'fixed',
//                     top: '20px',
//                     right: '20px',
//                     backgroundColor: successMessage.includes('❌') ? '#f44336' : '#4CAF50',
//                     color: 'white',
//                     padding: '15px 25px',
//                     borderRadius: '8px',
//                     boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
//                     zIndex: 9999,
//                     display: 'flex',
//                     alignItems: 'center',
//                     gap: '10px',
//                     animation: 'slideInRight 0.3s ease, fadeOut 0.3s ease 1.7s'
//                 }}>
//                     <span style={{ fontSize: '20px' }}>{successMessage.includes('✅') ? '✓' : '✗'}</span>
//                     <span style={{ fontWeight: 'bold' }}>{successMessage}</span>
//                 </div>
//             )}

//             {/* Main Scrollable Container */}
//             <div style={{
//                 height: 'calc(90vh - 150px)', // Adjust based on your layout
//                 overflowY: 'auto',
//                 overflowX: 'hidden',
//                 paddingRight: '10px',
//                 scrollbarWidth: 'thin',
//                 scrollbarColor: '#888 #f1f1f1'
//             }}>
//                 {orders.length === 0 ? (
//                     <div style={{
//                         textAlign: "center",
//                         padding: "40px",
//                         fontSize: "18px",
//                         color: "#666"
//                     }}>
//                         No pending orders found
//                     </div>
//                 ) : (
//                     orders.map((order) => {
//                         const orderId = order.id || order.orderId;
//                         const totalPlates = getTotalPlates(order);
//                         const location = formatLocation(order);

//                         const currentAmounts = editableAmounts[orderId] || {
//                             budget: order.budget?.toString() || "",
//                             paymentAmount: order.paymentAmount?.toString() || ""
//                         };
//                         const isEditing = editMode[orderId] || false;

//                         return (
//                             <div key={orderId} style={styles.card}>
//                                 {/* ===== Header ===== */}
//                                 <div style={styles.header}>
//                                     <div>
//                                         <h3 style={styles.orderId}>Enquiry Id: {orderId}</h3>
//                                     </div>

//                                     <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
//                                         <p style={{ fontWeight: "bold", fontSize: "16px", marginBottom: "0rem" }}>
//                                             Budget:
//                                         </p>
//                                         {isEditing ? (
//                                             <input
//                                                 type="text"
//                                                 value={currentAmounts.budget}
//                                                 onChange={(e) => handleAmountChange(orderId, 'budget', e.target.value)}
//                                                 placeholder="Enter budget"
//                                                 style={styles.amountInput}
//                                             />
//                                         ) : (
//                                             <span style={styles.amountDisplay}>
//                                                 ₹{currentAmounts.budget || '0'}
//                                             </span>
//                                         )}

//                                         {!isEditing && !order.adminPermision && (
//                                             <button
//                                                 onClick={() => handleEditClick(orderId)}
//                                                 style={styles.editButton}
//                                             >
//                                                 Edit
//                                             </button>
//                                         )}
//                                     </div>

//                                     <button
//                                         style={styles.dropdownBtn}
//                                         onClick={() =>
//                                             setShowDetails((prev) => ({
//                                                 ...prev,
//                                                 [orderId]: !prev[orderId],
//                                             }))
//                                         }
//                                     >
//                                         {showDetails[orderId] ? "▲" : "▼"}
//                                     </button>
//                                 </div>

//                                 {/* ===== Order Details ===== */}
//                                 <div
//                                     style={{
//                                         marginTop: "0px",
//                                         background: "linear-gradient(to right, rgb(244 107 68), rgb(238, 168, 73))",
//                                         padding: "0px",
//                                         borderRadius: "5px",
//                                         display: "flex",
//                                         justifyContent: "space-between",
//                                         alignItems: "flex-start",
//                                         flexWrap: "wrap",
//                                         color: "#000",
//                                         fontSize: "16px",
//                                         gap: "40px",
//                                         marginLeft: "30px",
//                                     }}
//                                 >
//                                     {/* Left Column */}
//                                     <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
//                                         <div style={{ display: "flex", alignItems: "center", marginBottom: "0px" }}>
//                                             <span style={{ minWidth: "120px" }}><strong>Category</strong></span>
//                                             <span style={{ minWidth: "20px" }}>:</span>
//                                             <span style={{ color: "black" }}>
//                                                 {order.event || "N/A"}
//                                             </span>
//                                         </div>
//                                         <div style={{ display: "flex", alignItems: "center", marginBottom: "0px" }}>
//                                             <span style={{ minWidth: "120px" }}><strong>Event Type</strong></span>
//                                             <span style={{ minWidth: "20px" }}>:</span>
//                                             <span style={{ color: "black" }}>
//                                                 {order.eventType || "N/A"}
//                                             </span>
//                                         </div>
//                                         <div style={{ display: "flex", alignItems: "center", marginBottom: "0px" }}>
//                                             <span style={{ minWidth: "120px" }}><strong>Date</strong></span>
//                                             <span style={{ minWidth: "20px" }}>:</span>
//                                             <span>{formatDate(order.eventDate)}</span>
//                                         </div>
//                                         <div style={{ display: "flex", alignItems: "center", marginBottom: "0px" }}>
//                                             <span style={{ minWidth: "120px" }}><strong>Time</strong></span>
//                                             <span style={{ minWidth: "20px" }}>:</span>
//                                             <span>{order.eventTime || "Not specified"}</span>
//                                         </div>
//                                     </div>

//                                     {/* Middle Column */}
//                                     <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
//                                         <div style={{ display: "flex", alignItems: "center", marginBottom: "0px" }}>
//                                             <span style={{ minWidth: "120px" }}><strong>Name</strong></span>
//                                             <span style={{ minWidth: "20px" }}>:</span>
//                                             <span>{order.fullName || order.name}</span>
//                                         </div>
//                                         <div style={{ display: "flex", alignItems: "center", marginBottom: "0px" }}>
//                                             <span style={{ minWidth: "120px" }}><strong>Mobile</strong></span>
//                                             <span style={{ minWidth: "20px" }}>:</span>
//                                             <span>{order.phoneNumber || order.mobile}</span>
//                                         </div>
//                                         <div style={{ display: "flex", alignItems: "center", marginBottom: "0px" }}>
//                                             <span style={{ minWidth: "120px" }}><strong>Email</strong></span>
//                                             <span style={{ minWidth: "20px" }}>:</span>
//                                             <span>{order.email}</span>
//                                         </div>
//                                         {/* <div style={{ display: "flex", alignItems: "center", marginBottom: "0px" }}>
//                                         <span style={{ minWidth: "120px" }}><strong>Plates</strong></span>
//                                         <span style={{ minWidth: "20px" }}>:</span>
//                                         <span>{totalPlates}</span>
//                                     </div> */}
//                                     </div>

//                                     {/* Right Column */}
//                                     <div
//                                         style={{
//                                             display: "flex",
//                                             flexDirection: "column",
//                                             gap: "6px",
//                                             marginRight: "40px",
//                                             alignItems: "flex-start",
//                                         }}
//                                     >
//                                         <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
//                                             <span style={{ minWidth: "120px", fontWeight: "bold" }}>Location</span>
//                                             <span style={{ minWidth: "20px" }}>:</span>
//                                             <span>
//                                                 {location}
//                                             </span>
//                                         </div>
//                                     </div>
//                                 </div>

//                                 {/* ===== Order Items Table (expandable) ===== */}
//                                 {showDetails[orderId] && (
//                                     <div>
//                                         {/* Plates Summary Table */}
//                                         <div style={{ marginTop: "15px" }}>
//                                             <table
//                                                 style={{
//                                                     width: "100%",
//                                                     borderCollapse: "collapse",
//                                                     marginTop: "0.5rem",
//                                                 }}
//                                                 className="leads-plates-table"
//                                             >
//                                                 <thead>
//                                                     <tr style={{
//                                                         backgroundColor: "rgb(230 109 51)",
//                                                         textAlign: "center",
//                                                         color: "white"
//                                                     }}>
//                                                         <th style={{ padding: "10px", border: "1px solid #ddd" }}>Veg Plates</th>
//                                                         <th style={{ padding: "10px", border: "1px solid #ddd" }}>Non-Veg Plates</th>
//                                                         {/* <th style={{ padding: "10px", border: "1px solid #ddd" }}>Mixed Plates</th> */}
//                                                         <th style={{
//                                                             padding: "10px",
//                                                             border: "1px solid #ddd",
//                                                         }}>Total Plates</th>
//                                                     </tr>
//                                                 </thead>
//                                                 <tbody>
//                                                     <tr style={{
//                                                         textAlign: "center",
//                                                         fontWeight: "bold",
//                                                         fontSize: "16px",
//                                                         backgroundColor: "#e9f5e9"
//                                                     }}>
//                                                         <td style={{
//                                                             padding: "12px",
//                                                             border: "1px solid #ddd",
//                                                             color: "#22863a"
//                                                         }}>
//                                                             {order.vegPlates || 0}
//                                                         </td>
//                                                         <td style={{
//                                                             padding: "12px",
//                                                             border: "1px solid #ddd",
//                                                             color: "#d73a49"
//                                                         }}>
//                                                             {order.nonVegPlates || 0}
//                                                         </td>
//                                                         {/* <td style={{
//                                                         padding: "12px",
//                                                         border: "1px solid #ddd",
//                                                         color: "#005cc5"
//                                                     }}>
//                                                         {order.mixedPlates || 0}
//                                                     </td> */}
//                                                         <td style={{
//                                                             padding: "12px",
//                                                             border: "1px solid #ddd",
//                                                             color: "black",
//                                                             fontSize: "18px"
//                                                         }}>
//                                                             {totalPlates}
//                                                         </td>
//                                                     </tr>
//                                                 </tbody>
//                                             </table>
//                                         </div>

//                                         {/* SIMPLIFIED MENU ITEMS SECTION */}
//                                         {order.items && typeof order.items === 'object' && (
//                                             <div style={{ marginTop: "15px" }}>
//                                                 <div style={{
//                                                     backgroundColor: "#f8f9fa",
//                                                     border: "1px solid #dee2e6",
//                                                     borderRadius: "6px",
//                                                     padding: "0",
//                                                     overflow: "hidden"
//                                                 }}>
//                                                     {/* Heading */}
//                                                     <div style={{
//                                                         backgroundColor: "#e9ecef",
//                                                         color: "#495057",
//                                                         padding: "10px 15px",
//                                                         fontSize: "15px",
//                                                         fontWeight: "600",
//                                                         borderBottom: "1px solid #dee2e6"
//                                                     }}>
//                                                         Menu Items
//                                                     </div>

//                                                     {/* Display items directly from the items object */}
//                                                     <div style={{ padding: "15px" }}>
//                                                         {Object.entries(order.items).map(([category, items]) => {
//                                                             if (!Array.isArray(items)) return null;

//                                                             return (
//                                                                 <div key={category} style={{ marginBottom: "20px" }}>
//                                                                     <h5 style={{
//                                                                         color: "rgb(230 109 51)",
//                                                                         marginBottom: "10px",
//                                                                         fontSize: "16px",
//                                                                         fontWeight: "600",
//                                                                         borderBottom: "2px solid rgb(230 109 51)",
//                                                                         paddingBottom: "5px"
//                                                                     }}>
//                                                                         {category} ({items.length})
//                                                                     </h5>

//                                                                     <div style={{
//                                                                         display: "grid",
//                                                                         gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
//                                                                         gap: "10px"
//                                                                     }}>
//                                                                         {items.map((item, index) => {
//                                                                             const nonVeg = isNonVeg(item);
//                                                                             return (
//                                                                                 <div
//                                                                                     key={index}
//                                                                                     style={{
//                                                                                         backgroundColor: "white",
//                                                                                         border: nonVeg ? "1px solid #ffcdd2" : "1px solid #c8e6c9",
//                                                                                         borderRadius: "5px",
//                                                                                         padding: "12px",
//                                                                                         fontSize: "14px",
//                                                                                         color: "#212529",
//                                                                                         boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
//                                                                                         display: "flex",
//                                                                                         alignItems: "center",
//                                                                                         justifyContent: "space-between",
//                                                                                         borderLeft: nonVeg ? "4px solid #f44336" : "4px solid #4caf50"
//                                                                                     }}
//                                                                                 >
//                                                                                     <div style={{ fontWeight: "500" }}>
//                                                                                         {item}
//                                                                                     </div>
//                                                                                     <span style={nonVeg ? styles.nonVegBadge : styles.vegBadge}>
//                                                                                         {nonVeg ? 'Non-Veg' : 'Veg'}
//                                                                                     </span>
//                                                                                 </div>
//                                                                             );
//                                                                         })}
//                                                                     </div>
//                                                                 </div>
//                                                             );
//                                                         })}
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         )}

//                                         {/* Add-Ons Section */}
//                                         {order.addOns && Array.isArray(order.addOns) && order.addOns.length > 0 && (
//                                             <div style={{ marginTop: "15px" }}>
//                                                 <div style={{
//                                                     backgroundColor: "#f8f9fa",
//                                                     border: "1px solid #dee2e6",
//                                                     borderRadius: "6px",
//                                                     padding: "0",
//                                                     overflow: "hidden"
//                                                 }}>
//                                                     {/* Add-Ons Heading */}
//                                                     <div style={{
//                                                         backgroundColor: "#e9ecef",
//                                                         color: "#495057",
//                                                         padding: "10px 15px",
//                                                         fontSize: "15px",
//                                                         fontWeight: "600",
//                                                         borderBottom: "1px solid #dee2e6"
//                                                     }}>
//                                                         Add-Ons ({order.addOns.filter(addon => addon.selected).length})
//                                                     </div>

//                                                     {/* Add-Ons Grid */}
//                                                     <div style={{
//                                                         padding: "15px",
//                                                         display: "grid",
//                                                         gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
//                                                         gap: "10px"
//                                                     }}>
//                                                         {order.addOns
//                                                             .filter(addon => addon.selected)
//                                                             .map((addon, index) => (
//                                                                 <div
//                                                                     key={index}
//                                                                     style={{
//                                                                         backgroundColor: "white",
//                                                                         border: "1px solid #d4edda",
//                                                                         borderRadius: "5px",
//                                                                         padding: "12px",
//                                                                         fontSize: "14px",
//                                                                         color: "#155724",
//                                                                         textAlign: "center",
//                                                                         boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
//                                                                         display: "flex",
//                                                                         alignItems: "center",
//                                                                         justifyContent: "space-between",
//                                                                         minHeight: "45px",
//                                                                         borderLeft: "4px solid #28a745"
//                                                                     }}
//                                                                 >
//                                                                     <div style={{ fontWeight: "600" }}>
//                                                                         {formatAddOnName(addon.addOnType)}
//                                                                     </div>
//                                                                     <div style={{
//                                                                         backgroundColor: "#28a745",
//                                                                         color: "white",
//                                                                         borderRadius: "20px",
//                                                                         padding: "2px 10px",
//                                                                         fontSize: "12px",
//                                                                         fontWeight: "bold"
//                                                                     }}>
//                                                                         Qty: {addon.quantity}
//                                                                     </div>
//                                                                 </div>
//                                                             ))}
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         )}

//                                         {/* Additional Requests */}
//                                         {order.additionalRequests && (
//                                             <div style={{ marginTop: "15px" }}>
//                                                 <div style={{
//                                                     backgroundColor: "#fff3cd",
//                                                     border: "1px solid #ffeaa7",
//                                                     borderRadius: "6px",
//                                                     padding: "12px 15px",
//                                                     color: "#856404",
//                                                     fontSize: "14px"
//                                                 }}>
//                                                     <span style={{ fontWeight: "bold" }}>Additional Requests: </span>
//                                                     {order.additionalRequests}
//                                                 </div>
//                                             </div>
//                                         )}

//                                         {/* Budget and Payment Amount Section */}
//                                         <div style={{
//                                             marginTop: "15px",
//                                             backgroundColor: "#f8f9fa",
//                                             border: "1px solid #dee2e6",
//                                             borderRadius: "6px",
//                                             padding: "15px"
//                                         }}>
//                                             <div style={{
//                                                 display: "flex",
//                                                 justifyContent: "space-between",
//                                                 alignItems: "center",
//                                                 flexWrap: "wrap",
//                                                 gap: "20px"
//                                             }}>
//                                                 <div style={{ flex: 1, minWidth: "200px" }}>
//                                                     <div style={{
//                                                         fontSize: "13px",
//                                                         color: "#6c757d",
//                                                         marginBottom: "4px",
//                                                         fontWeight: "500"
//                                                     }}>
//                                                         Budget
//                                                     </div>
//                                                     <div style={{
//                                                         display: "flex",
//                                                         alignItems: "center",
//                                                         gap: "10px"
//                                                     }}>
//                                                         <span style={{ fontSize: "16px", fontWeight: "bold" }}>₹</span>
//                                                         {isEditing ? (
//                                                             <input
//                                                                 type="text"
//                                                                 value={currentAmounts.budget}
//                                                                 onChange={(e) => handleAmountChange(orderId, 'budget', e.target.value)}
//                                                                 placeholder="Enter amount"
//                                                                 style={{
//                                                                     ...styles.amountInput,
//                                                                     width: "150px",
//                                                                     fontSize: "18px"
//                                                                 }}
//                                                             />
//                                                         ) : (
//                                                             <span style={styles.amountDisplay}>
//                                                                 {currentAmounts.budget || '0'}
//                                                             </span>
//                                                         )}
//                                                     </div>
//                                                 </div>
//                                                 <div style={{ flex: 1, minWidth: "200px" }}>
//                                                     <div style={{
//                                                         fontSize: "13px",
//                                                         color: "#6c757d",
//                                                         marginBottom: "4px",
//                                                         fontWeight: "500"
//                                                     }}>
//                                                         Including Lead Price
//                                                     </div>
//                                                     <div style={{
//                                                         display: "flex",
//                                                         alignItems: "center",
//                                                         gap: "10px"
//                                                     }}>
//                                                         <span style={{ fontSize: "16px", fontWeight: "bold" }}>₹</span>
//                                                         {isEditing ? (
//                                                             <input
//                                                                 type="text"
//                                                                 value={currentAmounts.paymentAmount}
//                                                                 onChange={(e) => handleAmountChange(orderId, 'paymentAmount', e.target.value)}
//                                                                 placeholder="Enter amount"
//                                                                 style={{
//                                                                     ...styles.amountInput,
//                                                                     width: "150px",
//                                                                     fontSize: "18px",
//                                                                     borderColor: "rgb(230 109 51)"
//                                                                 }}
//                                                             />
//                                                         ) : (
//                                                             <span style={styles.amountDisplay}>
//                                                                 {currentAmounts.paymentAmount || '0'}
//                                                             </span>
//                                                         )}
//                                                     </div>
//                                                 </div>
//                                                 <div>
//                                                     {isEditing && (
//                                                         <button
//                                                             onClick={() => handleCancelEdit(orderId)}
//                                                             style={styles.cancelButton}
//                                                         >
//                                                             Cancel
//                                                         </button>
//                                                     )}
//                                                 </div>
//                                             </div>
//                                         </div>

//                                         {/* Vendor Selection Component with company name only */}
//                                         <OrderVendorSelection
//                                             vendors={vendors}
//                                             order={order}
//                                             onSendApproval={handleSendApproval}
//                                         />
//                                     </div>
//                                 )}
//                             </div>
//                         );
//                     })
//                 )}
//             </div>

//             {/* Custom Scrollbar Styles */}
//             <style>{`
//             @keyframes slideInRight {
//                 from {
//                     opacity: 0;
//                     transform: translateX(100%);
//                 }
//                 to {
//                     opacity: 1;
//                     transform: translateX(0);
//                 }
//             }

//             @keyframes fadeOut {
//                 from {
//                     opacity: 1;
//                 }
//                 to {
//                     opacity: 0;
//                 }
//             }

//             /* Webkit scrollbar styles */
//             div::-webkit-scrollbar {
//                 width: 8px;
//                 height: 8px;
//             }

//             div::-webkit-scrollbar-track {
//                 background: #f1f1f1;
//                 border-radius: 4px;
//             }

//             div::-webkit-scrollbar-thumb {
//                 background: #888;
//                 border-radius: 4px;
//             }

//             div::-webkit-scrollbar-thumb:hover {
//                 background: #555;
//             }
//         `}</style>
//         </div>
//     );
// };

// // Simplified Vendor Selection Component - Company Name Only
// const OrderVendorSelection = ({ vendors, order, onSendApproval }) => {
//     const [selectedVendors, setSelectedVendors] = useState([]);
//     const [showDropdown, setShowDropdown] = useState(false);
//     const [showSuccessPopup, setShowSuccessPopup] = useState(false);
//     const [successMessage, setSuccessMessage] = useState("");
//     const [searchTerm, setSearchTerm] = useState("");
//     const [isApproved, setIsApproved] = useState(false); // State to track approval status

//     // Auto-close success popup
//     useEffect(() => {
//         if (showSuccessPopup) {
//             const timer = setTimeout(() => {
//                 setShowSuccessPopup(false);
//                 setSuccessMessage("");
//             }, 2000);
//             return () => clearTimeout(timer);
//         }
//     }, [showSuccessPopup]);

//     // Handle checkbox selection
//     const handleSelectVendor = (vendorId) => {
//         if (isApproved) return; // Prevent selection if already approved

//         setSelectedVendors(prev => {
//             if (prev.includes(vendorId)) {
//                 return prev.filter(id => id !== vendorId);
//             } else {
//                 return [...prev, vendorId];
//             }
//         });
//     };

//     // Handle select all in dropdown
//     const handleSelectAll = () => {
//         if (isApproved) return; // Prevent select all if already approved

//         if (selectedVendors.length === filteredVendors.length && filteredVendors.length > 0) {
//             // Deselect all filtered
//             const filteredIds = filteredVendors.map(v => v.id);
//             setSelectedVendors(prev => prev.filter(id => !filteredIds.includes(id)));
//         } else {
//             // Select all filtered
//             const filteredIds = filteredVendors.map(v => v.id);
//             setSelectedVendors(prev => {
//                 const newSelected = [...new Set([...prev, ...filteredIds])];
//                 return newSelected;
//             });
//         }
//     };

//     // Filter vendors based on search (company name only)
//     const filteredVendors = (vendors || []).filter(vendor => {
//         const searchLower = searchTerm.toLowerCase();
//         return vendor.companyName?.toLowerCase().includes(searchLower);
//     });

//     // Send to all vendors
//     const handleSendToAllVendors = () => {
//         if (isApproved) return; // Prevent action if already approved

//         onSendApproval(order, [], true);
//         setShowDropdown(false);
//         setSelectedVendors([]);
//         setIsApproved(true); // Set approved state to true
//     };

//     // Handle approve after selection
//     const handleApprove = () => {
//         if (isApproved) return; // Prevent action if already approved

//         if (selectedVendors.length === 0) {
//             setSuccessMessage("❌ Please select at least one vendor to approve");
//             setShowSuccessPopup(true);
//             return;
//         }

//         onSendApproval(order, selectedVendors, false);
//         setShowDropdown(false);
//         setIsApproved(true); // Set approved state to true
//     };

//     const buttonContainerStyle = {
//         display: "flex",
//         justifyContent: "center",
//         gap: "20px",
//         marginBottom: "20px",
//         flexWrap: "wrap"
//     };

//     const primaryButtonStyle = {
//         backgroundColor: isApproved ? "#6c757d" : "#28a745", // Gray if approved
//         color: "#fff",
//         border: "none",
//         padding: "12px 30px",
//         borderRadius: "6px",
//         cursor: isApproved ? "not-allowed" : "pointer",
//         fontWeight: "bold",
//         fontSize: "16px",
//         minWidth: "180px",
//         transition: "all 0.3s ease",
//         opacity: isApproved ? 0.7 : 1
//     };

//     const secondaryButtonStyle = {
//         backgroundColor: isApproved ? "#6c757d" : "#ffc107", // Gray if approved
//         color: isApproved ? "#fff" : "#333",
//         border: "none",
//         padding: "12px 30px",
//         borderRadius: "6px",
//         cursor: isApproved ? "not-allowed" : "pointer",
//         fontWeight: "bold",
//         fontSize: "16px",
//         minWidth: "180px",
//         transition: "all 0.3s ease",
//         opacity: isApproved ? 0.7 : 1
//     };

//     const approveButtonStyle = {
//         backgroundColor: isApproved ? "#6c757d" : "rgb(230 109 51)", // Gray if approved
//         color: "#fff",
//         border: "none",
//         padding: "14px 40px",
//         borderRadius: "6px",
//         cursor: isApproved ? "not-allowed" : "pointer",
//         fontWeight: "bold",
//         fontSize: "18px",
//         marginTop: "20px",
//         width: "100%",
//         maxWidth: "400px",
//         marginLeft: "auto",
//         marginRight: "auto",
//         display: "block",
//         transition: "all 0.3s ease",
//         opacity: isApproved ? 0.7 : 1
//     };

//     const approvedContainerStyle = {
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "center",
//         marginTop: "20px"
//     };

//     const approvedBadgeStyle = {
//         backgroundColor: "#28a745",
//         color: "white",
//         padding: "14px 40px",
//         borderRadius: "6px",
//         fontWeight: "bold",
//         fontSize: "18px",
//         display: "inline-flex",
//         alignItems: "center",
//         justifyContent: "center",
//         gap: "10px",
//         width: "100%",
//         maxWidth: "400px"
//     };

//     const dropdownStyle = {
//         marginTop: "15px",
//         border: "1px solid #ddd",
//         borderRadius: "8px",
//         backgroundColor: "white",
//         boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
//         maxHeight: "400px",
//         overflow: "hidden",
//         display: showDropdown && !isApproved ? "block" : "none" // Hide dropdown if approved
//     };

//     const dropdownHeaderStyle = {
//         padding: "15px",
//         borderBottom: "1px solid #eee",
//         backgroundColor: "#f8f9fa"
//     };

//     const searchInputStyle = {
//         width: "100%",
//         padding: "10px",
//         border: "1px solid #ddd",
//         borderRadius: "4px",
//         fontSize: "14px",
//         marginBottom: "10px"
//     };

//     const selectAllStyle = {
//         display: "flex",
//         alignItems: "center",
//         gap: "10px",
//         padding: "10px 0",
//         borderBottom: "1px solid #eee",
//         cursor: "pointer"
//     };

//     const vendorItemStyle = {
//         display: "flex",
//         alignItems: "center",
//         gap: "10px",
//         padding: "12px 15px",
//         borderBottom: "1px solid #f0f0f0",
//         cursor: "pointer",
//         transition: "background-color 0.2s"
//     };

//     const companyNameStyle = {
//         fontWeight: "600",
//         color: "#333",
//         fontSize: "15px"
//     };

//     return (
//         <div style={{ marginTop: "20px", borderTop: "2px solid rgb(230 109 51)", paddingTop: "15px", position: "relative" }}>
//             {/* Success Popup for vendor actions */}
//             {showSuccessPopup && (
//                 <div style={{
//                     position: 'fixed',
//                     top: '20px',
//                     right: '20px',
//                     backgroundColor: successMessage.includes('❌') ? '#f44336' : '#4CAF50',
//                     color: 'white',
//                     padding: '15px 25px',
//                     borderRadius: '8px',
//                     boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
//                     zIndex: 9999,
//                     display: 'flex',
//                     alignItems: 'center',
//                     gap: '10px',
//                     animation: 'slideInRight 0.3s ease, fadeOut 0.3s ease 1.7s'
//                 }}>
//                     <span style={{ fontSize: '20px' }}>{successMessage.includes('✅') ? '✓' : '✗'}</span>
//                     <span style={{ fontWeight: 'bold' }}>{successMessage}</span>
//                 </div>
//             )}

//             <h4 style={{ marginBottom: "15px", color: "#333", textAlign: "center" }}>Select Vendors for Order Assignment</h4>

//             {/* Centered Action Buttons */}
//             {isApproved ? (
//                 // Show only one approved badge when approved
//                 <div style={approvedContainerStyle}>
//                     <div style={approvedBadgeStyle}>
//                         <span>✓</span> Approved
//                     </div>
//                 </div>
//             ) : (
//                 // Show both buttons when not approved
//                 <div style={buttonContainerStyle}>
//                     <button
//                         onClick={handleSendToAllVendors}
//                         style={primaryButtonStyle}
//                     >
//                         All Vendors
//                     </button>
//                     <button
//                         onClick={() => setShowDropdown(!showDropdown)}
//                         style={secondaryButtonStyle}
//                     >
//                         Select Vendors {selectedVendors.length > 0 ? `(${selectedVendors.length})` : ''}
//                     </button>
//                 </div>
//             )}

//             {/* Dropdown with Vendor List */}
//             <div style={dropdownStyle}>
//                 <div style={dropdownHeaderStyle}>
//                     {/* Search Bar - Company Name only */}
//                     <input
//                         type="text"
//                         placeholder="Search by company name..."
//                         value={searchTerm}
//                         onChange={(e) => setSearchTerm(e.target.value)}
//                         style={searchInputStyle}
//                     />

//                     {/* Select All Option */}
//                     <div
//                         style={selectAllStyle}
//                         onClick={handleSelectAll}
//                     >
//                         <input
//                             type="checkbox"
//                             checked={filteredVendors.length > 0 && selectedVendors.length === filteredVendors.length}
//                             onChange={handleSelectAll}
//                             onClick={(e) => e.stopPropagation()}
//                         />
//                         <span style={{ fontWeight: "500" }}>
//                             Select All {filteredVendors.length} {filteredVendors.length === 1 ? 'Vendor' : 'Vendors'}
//                         </span>
//                         <span style={{ marginLeft: "auto", color: "#666", fontSize: "13px" }}>
//                             {selectedVendors.length} selected
//                         </span>
//                     </div>
//                 </div>

//                 {/* Vendor List with Scroll - Company Name Only */}
//                 <div style={{
//                     maxHeight: "300px",
//                     overflowY: "auto",
//                     padding: "5px 0"
//                 }}>
//                     {filteredVendors.length > 0 ? (
//                         filteredVendors.map((vendor) => (
//                             <div
//                                 key={vendor.id}
//                                 style={{
//                                     ...vendorItemStyle,
//                                     backgroundColor: selectedVendors.includes(vendor.id) ? "#f0e6ff" : "white",
//                                     borderLeft: selectedVendors.includes(vendor.id) ? "4px solid rgb(230 109 51)" : "4px solid transparent"
//                                 }}
//                                 onClick={() => handleSelectVendor(vendor.id)}
//                             >
//                                 <input
//                                     type="checkbox"
//                                     checked={selectedVendors.includes(vendor.id)}
//                                     onChange={() => handleSelectVendor(vendor.id)}
//                                     onClick={(e) => e.stopPropagation()}
//                                 />
//                                 <div style={companyNameStyle}>
//                                     {vendor.companyName}
//                                 </div>
//                             </div>
//                         ))
//                     ) : (
//                         <div style={{ padding: "20px", textAlign: "center", color: "#666" }}>
//                             No vendors found matching "{searchTerm}"
//                         </div>
//                     )}
//                 </div>

//                 {/* Selected Count Footer */}
//                 <div style={{
//                     padding: "10px 15px",
//                     borderTop: "1px solid #eee",
//                     backgroundColor: "#f8f9fa",
//                     fontSize: "13px",
//                     color: "#666",
//                     display: "flex",
//                     justifyContent: "space-between",
//                     alignItems: "center"
//                 }}>
//                     <span>{selectedVendors.length} vendor{selectedVendors.length !== 1 ? 's' : ''} selected</span>
//                     <span>Total: {vendors.length} vendors</span>
//                 </div>
//             </div>

//             {/* Approve Button - Only show if not approved */}
//             {!isApproved && (
//                 <button
//                     onClick={handleApprove}
//                     style={approveButtonStyle}
//                 >
//                     Approve Order for Selected Vendors
//                 </button>
//             )}
//         </div>
//     );
// };

// export default Vendordersdetails;







import React, { useState, useEffect } from "react";
import {
    getCateringOrders,
    getCateringVendors,
    debugAdminApi,
    approveCateringOrder
} from "../../../Servicefile/ordermanagementservice.jsx";

// ============================================
// PREMIUM ICONS COMPONENT
// ============================================
const Icons = {
    Expand: () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="6 9 12 15 18 9"/>
        </svg>
    ),
    Collapse: () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="18 15 12 9 6 15"/>
        </svg>
    ),
    Edit: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
            <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
        </svg>
    ),
    Save: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/>
            <polyline points="17 21 17 13 7 13 7 21"/>
            <polyline points="7 3 7 8 15 8"/>
        </svg>
    ),
    Cancel: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18"/>
            <line x1="6" y1="6" x2="18" y2="18"/>
        </svg>
    ),
    Check: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
            <polyline points="20 6 9 17 4 12"/>
        </svg>
    ),
    Veg: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#2e7d32" strokeWidth="2">
            <circle cx="12" cy="12" r="10"/>
            <path d="M12 6v6l4 2"/>
        </svg>
    ),
    NonVeg: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#d32f2f" strokeWidth="2">
            <circle cx="12" cy="12" r="10"/>
            <line x1="8" y1="8" x2="16" y2="16"/>
            <line x1="16" y1="8" x2="8" y2="16"/>
        </svg>
    ),
    Location: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
            <circle cx="12" cy="10" r="3"/>
        </svg>
    ),
    Calendar: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
            <line x1="16" y1="2" x2="16" y2="6"/>
            <line x1="8" y1="2" x2="8" y2="6"/>
            <line x1="3" y1="10" x2="21" y2="10"/>
        </svg>
    ),
    Clock: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10"/>
            <polyline points="12 6 12 12 16 14"/>
        </svg>
    ),
    User: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
            <circle cx="12" cy="7" r="4"/>
        </svg>
    ),
    Phone: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.362 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.574 2.81.7A2 2 0 0 1 22 16.92z"/>
        </svg>
    ),
    Email: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="2" y="4" width="20" height="16" rx="2"/>
            <path d="M22 7l-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>
        </svg>
    ),
    NoData: () => (
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#6c757d" strokeWidth="1.5">
            <rect x="2" y="3" width="20" height="18" rx="2"/>
            <line x1="8" y1="21" x2="16" y2="21"/>
            <line x1="12" y1="17" x2="12" y2="21"/>
            <path d="M8 7h8M8 11h6M8 15h4"/>
        </svg>
    ),
    Plate: () => (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20z"/>
            <path d="M12 6v6l4 2"/>
        </svg>
    ),
    Vendor: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="2" y="7" width="20" height="14" rx="2" ry="2"/>
            <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/>
        </svg>
    ),
    Budget: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10"/>
            <path d="M8 12h8"/>
            <path d="M12 8v8"/>
        </svg>
    ),
    Approved: () => (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#065f46" strokeWidth="2">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
            <polyline points="22 4 12 14.01 9 11.01"/>
        </svg>
    )
};

// ============================================
// PREMIUM STYLES
// ============================================
const styles = {
    container: {
        padding: '1px 5px',
            borderRadius: '16px',
        boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
        minHeight: '500px'
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '0 0 16px 0',
        borderBottom: '2px solid #e9ecef',
        flexWrap: 'wrap',
        gap: '12px'
    },
    title: {
        fontSize: '20px',
        fontWeight: '600',
        color: '#2d3748',
        letterSpacing: '-0.3px',
        display: 'flex',
        alignItems: 'center',
        gap: '10px'
    },
    titleBadge: {
        background: 'rgb(230 109 51)',
        color: 'white',
        fontSize: '12px',
        fontWeight: '500',
        padding: '2px 12px',
        borderRadius: '12px',
        letterSpacing: '0.3px'
    },
    card: {
        background: 'white',
        borderRadius: '12px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
        marginBottom: '16px',
        overflow: 'hidden',
        border: '1px solid #edf2f7',
        transition: 'all 0.3s ease'
    },
    cardHeader: {
        padding: '16px 20px',
        background: 'linear-gradient(135deg, #f46b45 0%, #eea849 100%)',
        color: 'white',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: '10px'
    },
    cardBody: {
        padding: '20px'
    },
    orderId: {
        fontSize: '16px',
        fontWeight: '700',
        margin: 0,
        color: 'white',
        display: 'flex',
        alignItems: 'center',
        gap: '8px'
    },
    budgetSection: {
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        flexWrap: 'wrap'
    },
    budgetLabel: {
        fontSize: '13px',
        fontWeight: '600',
        opacity: 0.9,
        color: 'white'
    },
    budgetDisplay: {
        background: 'rgba(255,255,255,0.2)',
        padding: '6px 16px',
        borderRadius: '8px',
        fontWeight: '700',
        fontSize: '16px',
        color: 'white',
        backdropFilter: 'blur(4px)',
        minWidth: '80px',
        textAlign: 'center'
    },
    budgetInput: {
        background: 'white',
        padding: '6px 12px',
        borderRadius: '8px',
        border: '2px solid #ffd700',
        fontSize: '16px',
        fontWeight: '600',
        width: '140px',
        outline: 'none',
        color: '#2d3748',
        transition: 'all 0.3s ease'
    },
    infoGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
        gap: '12px',
        marginBottom: '16px'
    },
    infoItem: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        fontSize: '14px',
        color: '#2d3748'
    },
    infoLabel: {
        fontWeight: '600',
        color: '#4a5568',
        minWidth: '80px'
    },
    infoValue: {
        fontWeight: '500',
        color: '#1a202c'
    },
    badge: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px',
        padding: '3px 12px',
        borderRadius: '20px',
        fontSize: '11px',
        fontWeight: '500',
        letterSpacing: '0.3px'
    },
    vegBadge: {
        background: '#c6f6d5',
        color: '#276749'
    },
    nonVegBadge: {
        background: '#fed7d7',
        color: '#9b2c2c'
    },
    statusBadge: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px',
        padding: '4px 16px',
        borderRadius: '20px',
        fontSize: '12px',
        fontWeight: '600'
    },
    statusApproved: {
        background: '#c6f6d5',
        color: '#276749'
    },
    statusPending: {
        background: '#fefcbf',
        color: '#975a16'
    },
    statusRejected: {
        background: '#fed7d7',
        color: '#9b2c2c'
    },
    button: {
        padding: '8px 16px',
        borderRadius: '8px',
        border: 'none',
        fontWeight: '500',
        fontSize: '13px',
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        height: '38px',
        whiteSpace: 'nowrap'
    },
    buttonEdit: {
        background: '#ffc107',
        color: '#333',
        border: '1px solid #ffc107'
    },
    buttonSave: {
        background: 'rgb(230 109 51)',
        color: 'white'
    },
    buttonCancel: {
        background: '#e2e8f0',
        color: '#4a5568'
    },
    buttonPrimary: {
        background: 'rgb(230 109 51)',
        color: 'white'
    },
    buttonSuccess: {
        background: '#48bb78',
        color: 'white'
    },
    buttonSecondary: {
        background: '#e2e8f0',
        color: '#4a5568'
    },
    expandButton: {
        background: 'rgba(255,255,255,0.2)',
        border: 'none',
        borderRadius: '8px',
        padding: '8px',
        cursor: 'pointer',
        color: 'white',
        transition: 'all 0.3s ease',
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        fontSize: '13px'
    },
    tableWrapper: {
        borderRadius: '8px',
        border: '1px solid #edf2f7',
        overflow: 'auto',
        marginBottom: '16px'
    },
    table: {
        width: '100%',
        fontSize: '13px',
        borderCollapse: 'collapse'
    },
    th: {
        padding: '10px 14px',
        textAlign: 'center',
        fontWeight: '600',
        fontSize: '11px',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        color: 'white',
        background: 'rgb(230 109 51)',
        borderBottom: '2px solid #d45a1a'
    },
    td: {
        padding: '10px 14px',
        borderBottom: '1px solid #f1f5f9',
        textAlign: 'center',
        fontSize: '13px'
    },
    menuItem: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '10px 14px',
        borderRadius: '6px',
        border: '1px solid #edf2f7',
        marginBottom: '6px',
        transition: 'all 0.2s ease'
    },
    menuItemVeg: {
        borderLeft: '4px solid #48bb78'
    },
    menuItemNonVeg: {
        borderLeft: '4px solid #fc8181'
    },
    addOnItem: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '8px 14px',
        borderRadius: '6px',
        background: '#f0fff4',
        border: '1px solid #c6f6d5',
        marginBottom: '6px'
    },
    emptyState: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '60px 20px',
        color: '#a0aec0'
    },
    emptyStateText: {
        marginTop: '16px',
        fontSize: '16px',
        fontWeight: '500',
        color: '#4a5568'
    },
    emptyStateSubtext: {
        fontSize: '13px',
        color: '#a0aec0',
        marginTop: '4px'
    },
    statsBar: {
        display: 'flex',
        alignItems: 'center',
        gap: '16px',
        padding: '8px 0',
        fontSize: '12px',
        color: '#718096',
        flexWrap: 'wrap'
    },
    statItem: {
        display: 'flex',
        alignItems: 'center',
        gap: '4px'
    },
    statNumber: {
        fontWeight: '600',
        color: '#2d3748'
    },
    vendorDropdown: {
        marginTop: '16px',
        border: '1px solid #edf2f7',
        borderRadius: '10px',
        background: 'white',
        boxShadow: '0 4px 16px rgba(0,0,0,0.08)',
        overflow: 'hidden'
    },
    vendorItem: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        padding: '10px 16px',
        borderBottom: '1px solid #f1f5f9',
        cursor: 'pointer',
        transition: 'all 0.2s ease'
    },
    vendorItemSelected: {
        background: '#f0f4ff',
        borderLeft: '4px solid rgb(230 109 51)'
    },
    vendorName: {
        fontWeight: '500',
        color: '#2d3748',
        fontSize: '14px'
    },
    actionButtons: {
        display: 'flex',
        justifyContent: 'center',
        gap: '12px',
        marginTop: '16px',
        flexWrap: 'wrap'
    },
    approvedBadge: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        padding: '12px 32px',
        background: '#c6f6d5',
        color: '#276749',
        borderRadius: '8px',
        fontWeight: '700',
        fontSize: '16px',
        width: '100%',
        maxWidth: '400px',
        margin: '0 auto'
    },
    popup: {
        position: 'fixed',
        top: '20px',
        right: '20px',
        padding: '16px 24px',
        borderRadius: '10px',
        boxShadow: '0 4px 16px rgba(0,0,0,0.15)',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        animation: 'slideInRight 0.3s ease, fadeOut 0.3s ease 2.7s'
    },
    popupSuccess: {
        background: '#48bb78',
        color: 'white'
    },
    popupError: {
        background: '#fc8181',
        color: 'white'
    }
};

const Vendordersdetails = () => {
    const [showDetails, setShowDetails] = useState({});
    const [orders, setOrders] = useState([]);
    const [vendors, setVendors] = useState([]);
    const [editableAmounts, setEditableAmounts] = useState({});
    const [editMode, setEditMode] = useState({});
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [showSuccessPopup, setShowSuccessPopup] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");

    useEffect(() => {
        fetchOrders();
        fetchVendors();
        debugPermissions();
    }, []);

    useEffect(() => {
        if (showSuccessPopup) {
            const timer = setTimeout(() => {
                setShowSuccessPopup(false);
                setSuccessMessage("");
            }, 2000);
            return () => clearTimeout(timer);
        }
    }, [showSuccessPopup]);

    useEffect(() => {
        const checkAuth = () => {
            const authToken = localStorage.getItem("authToken");
            if (authToken && authToken.split('.').length === 3) {
                try {
                    const payload = JSON.parse(atob(authToken.split('.')[1]));
                    if (payload.exp) {
                        const expirationDate = new Date(payload.exp * 1000);
                        if (Date.now() >= payload.exp * 1000) {
                            console.log("⚠️ Token has expired!");
                        }
                    }
                } catch (e) {}
            }
        };
        checkAuth();
    }, []);

    const debugPermissions = async () => {
        const authToken = localStorage.getItem("authToken");
        try {
            const response = await debugAdminApi(authToken);
        } catch (e) {}
    };

    const fetchOrders = async () => {
        setLoading(true);
        setError(null);
        try {
            const authToken = localStorage.getItem("authToken");
            if (!authToken) throw new Error("No auth token found");
            const data = await getCateringOrders(authToken);
            const filteredData = Array.isArray(data) ? data.filter(item => item.adminPermision === false) : [];
            setOrders(filteredData);
            const initialAmounts = {};
            const initialEditMode = {};
            filteredData.forEach(order => {
                const orderId = order.id || order.orderId;
                initialAmounts[orderId] = {
                    budget: order.budget?.toString() || "",
                    paymentAmount: order.paymentAmount?.toString() || ""
                };
                initialEditMode[orderId] = false;
            });
            setEditableAmounts(initialAmounts);
            setEditMode(initialEditMode);
            localStorage.setItem("vendOrdersData", JSON.stringify(filteredData));
        } catch (err) {
            console.error("Error fetching orders:", err);
            setError("Failed to load orders.");
        } finally {
            setLoading(false);
        }
    };

    const fetchVendors = async () => {
        try {
            const authToken = localStorage.getItem("authToken");
            if (!authToken) return;
            const data = await getCateringVendors(authToken);
            const processedVendors = Array.isArray(data) ? data.map(vendor => ({
                id: vendor.vendorId || vendor.id,
                companyName: vendor.registeredName || vendor.companyName || vendor.name || "Company Name Not Available",
                vendorId: vendor.vendorId
            })) : [];
            setVendors(processedVendors);
        } catch (err) {
            console.error("Error fetching vendors:", err);
        }
    };

    const handleEditClick = (orderId) => {
        const order = orders.find(o => (o.id === orderId || o.orderId === orderId));
        if (order.adminPermision === true) {
            setSuccessMessage("❌ Cannot edit - Order already approved");
            setShowSuccessPopup(true);
            return;
        }
        setEditMode(prev => ({ ...prev, [orderId]: true }));
    };

    const handleCancelEdit = (orderId) => {
        const order = orders.find(o => (o.id === orderId || o.orderId === orderId));
        setEditableAmounts(prev => ({
            ...prev,
            [orderId]: {
                budget: order.budget?.toString() || "",
                paymentAmount: order.paymentAmount?.toString() || ""
            }
        }));
        setEditMode(prev => ({ ...prev, [orderId]: false }));
    };

    const handleAmountChange = (orderId, field, value) => {
        if (!editMode[orderId]) return;
        const regex = /^\d*\.?\d*$/;
        if (value === "" || regex.test(value)) {
            setEditableAmounts(prev => ({
                ...prev,
                [orderId]: {
                    ...prev[orderId],
                    [field]: value
                }
            }));
        }
    };

    const handleSendApproval = async (order, selectedVendorIds = [], assignToAll = false) => {
        const orderId = order.orderId || order.id;
        const authToken = localStorage.getItem("authToken");
        const updatedPaymentAmount = Number(editableAmounts[orderId]?.paymentAmount || order.paymentAmount || 0);

        const bodyData = {
            adminPermision: true,
            paymentAmount: updatedPaymentAmount,
            assignToAll: assignToAll,
            vendorIds: assignToAll ? null : selectedVendorIds
        };

        try {
            await approveCateringOrder(orderId, bodyData, authToken);
            setSuccessMessage(assignToAll ? "✅ Order approved and sent to all vendors!" : `✅ Order approved and sent to ${selectedVendorIds.length} vendor(s)!`);
            setShowSuccessPopup(true);
            setOrders(prev => prev.map(item => (item.id === orderId || item.orderId === orderId) ? { ...item, adminPermision: true } : item));
        } catch (err) {
            console.error("Approval Error:", err);
            setSuccessMessage("❌ " + (err.response?.data?.message || err.message));
            setShowSuccessPopup(true);
        }
    };

    const formatDate = (dateString) => dateString || "N/A";
    const getTotalPlates = (order) => (order.vegPlates || 0) + (order.nonVegPlates || 0) + (order.mixedPlates || 0);
    const formatLocation = (order) => {
        const parts = [];
        if (order.fullAddress) parts.push(order.fullAddress);
        if (order.city) parts.push(order.city);
        if (order.state) parts.push(order.state);
        if (order.pincode) parts.push(order.pincode);
        if (order.country) parts.push(order.country);
        return parts.join(', ');
    };
    const isNonVeg = (item) => {
        if (!item || typeof item !== 'string') return false;
        const nonVegKeywords = ['chicken', 'chiken', 'mutton', 'fish', 'egg', 'prawn', 'meat', 'beef', 'pork'];
        return nonVegKeywords.some(keyword => item.toLowerCase().includes(keyword));
    };
    const formatAddOnName = (addOnType) => {
        if (!addOnType) return '';
        return addOnType.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ');
    };

    // Calculate stats
    const totalOrders = orders.length;
    const totalPlates = orders.reduce((sum, order) => sum + getTotalPlates(order), 0);
    const totalBudget = orders.reduce((sum, order) => sum + (order.budget || 0), 0);

    if (loading) return <div style={{ textAlign: "center", padding: "40px", fontSize: "18px", color: "#666" }}>Loading orders...</div>;
    if (error) return <div style={{ textAlign: "center", padding: "40px", fontSize: "18px", color: "#ff4444" }}>{error}</div>;

    return (
        <div style={styles.container}>
            {/* Success Popup */}
            {showSuccessPopup && (
                <div style={{
                    ...styles.popup,
                    ...(successMessage.includes('❌') ? styles.popupError : styles.popupSuccess)
                }}>
                    <span style={{ fontSize: '20px' }}>{successMessage.includes('✅') ? '✓' : '✗'}</span>
                    <span style={{ fontWeight: 'bold' }}>{successMessage}</span>
                </div>
            )}

            {/* Header */}
            {/* <div style={styles.header}>
                <div style={styles.title}>
                    📋 Catering Orders
                    <span style={styles.titleBadge}>{totalOrders}</span>
                </div>
                <div>
                    <button onClick={fetchOrders} style={{ ...styles.button, ...styles.buttonPrimary }}>
                        <Icons.Check /> Refresh
                    </button>
                </div>
            </div> */}

           

            {/* Orders List */}
            <div style={{ maxHeight: 'calc(90vh - 300px)', overflowY: 'auto', paddingRight: '4px' }}>
                {orders.length === 0 ? (
                    <div style={styles.emptyState}>
                        <Icons.NoData />
                        <div style={styles.emptyStateText}>No pending orders found</div>
                        <div style={styles.emptyStateSubtext}>All orders have been processed or approved</div>
                    </div>
                ) : (
                    orders.map((order) => {
                        const orderId = order.id || order.orderId;
                        const totalPlates = getTotalPlates(order);
                        const location = formatLocation(order);
                        const currentAmounts = editableAmounts[orderId] || {
                            budget: order.budget?.toString() || "",
                            paymentAmount: order.paymentAmount?.toString() || ""
                        };
                        const isEditing = editMode[orderId] || false;
                        const isExpanded = showDetails[orderId] || false;

                        return (
                            <div key={orderId} style={styles.card}>
                                {/* Card Header */}
                                <div style={styles.cardHeader}>
                                    <div style={styles.orderId}>
                                        <span>📋</span> Enquiry: {orderId}
                                    </div>

                                    <div style={styles.budgetSection}>
                                        <span style={styles.budgetLabel}>Budget:</span>
                                        {isEditing ? (
                                            <input
                                                type="text"
                                                value={currentAmounts.budget}
                                                onChange={(e) => handleAmountChange(orderId, 'budget', e.target.value)}
                                                style={styles.budgetInput}
                                            />
                                        ) : (
                                            <span style={styles.budgetDisplay}>₹{currentAmounts.budget || '0'}</span>
                                        )}

                                        {!isEditing && !order.adminPermision && (
                                            <button onClick={() => handleEditClick(orderId)} style={{ ...styles.button, ...styles.buttonEdit }}>
                                                <Icons.Edit /> Edit
                                            </button>
                                        )}
                                    </div>

                                    <button style={styles.expandButton} onClick={() => setShowDetails(prev => ({ ...prev, [orderId]: !prev[orderId] }))}>
                                        {isExpanded ? <Icons.Collapse /> : <Icons.Expand />}
                                        {isExpanded ? 'Hide' : 'View'}
                                    </button>
                                </div>

                                {/* Card Body - Basic Info */}
                                <div style={styles.cardBody}>
                                    <div style={styles.infoGrid}>
                                        <div style={styles.infoItem}>
                                            <Icons.Calendar /> <span style={styles.infoLabel}>Date:</span>
                                            <span style={styles.infoValue}>{formatDate(order.eventDate)}</span>
                                        </div>
                                        <div style={styles.infoItem}>
                                            <Icons.Clock /> <span style={styles.infoLabel}>Time:</span>
                                            <span style={styles.infoValue}>{order.eventTime || "Not specified"}</span>
                                        </div>
                                        <div style={styles.infoItem}>
                                            <Icons.User /> <span style={styles.infoLabel}>Name:</span>
                                            <span style={styles.infoValue}>{order.fullName || order.name}</span>
                                        </div>
                                        <div style={styles.infoItem}>
                                            <Icons.Phone /> <span style={styles.infoLabel}>Mobile:</span>
                                            <span style={styles.infoValue}>{order.phoneNumber || order.mobile}</span>
                                        </div>
                                        <div style={styles.infoItem}>
                                            <Icons.Email /> <span style={styles.infoLabel}>Email:</span>
                                            <span style={styles.infoValue}>{order.email}</span>
                                        </div>
                                        <div style={styles.infoItem}>
                                            <Icons.Location /> <span style={styles.infoLabel}>Location:</span>
                                            <span style={styles.infoValue}>{location}</span>
                                        </div>
                                        <div style={styles.infoItem}>
                                            <span style={styles.infoLabel}>Category:</span>
                                            <span style={styles.infoValue}>{order.event || "N/A"}</span>
                                        </div>
                                        <div style={styles.infoItem}>
                                            <span style={styles.infoLabel}>Event Type:</span>
                                            <span style={styles.infoValue}>{order.eventType || "N/A"}</span>
                                        </div>
                                    </div>

                                    {/* Expandable Details */}
                                    {isExpanded && (
                                        <div>
                                            {/* Plates Summary */}
                                            <div style={styles.tableWrapper}>
                                                <table style={styles.table}>
                                                    <thead>
                                                        <tr>
                                                            <th style={styles.th}>Veg Plates</th>
                                                            <th style={styles.th}>Non-Veg Plates</th>
                                                            <th style={styles.th}>Total Plates</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr style={{ background: '#f7fafc' }}>
                                                            <td style={{ ...styles.td, color: '#276749', fontWeight: '700' }}>{order.vegPlates || 0}</td>
                                                            <td style={{ ...styles.td, color: '#9b2c2c', fontWeight: '700' }}>{order.nonVegPlates || 0}</td>
                                                            <td style={{ ...styles.td, fontWeight: '700', fontSize: '16px' }}>{totalPlates}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>

                                            {/* Menu Items */}
                                            {order.items && typeof order.items === 'object' && (
                                                <div style={{ marginBottom: '16px' }}>
                                                    <h5 style={{ color: 'rgb(230 109 51)', marginBottom: '10px', fontSize: '15px', fontWeight: '600', borderBottom: '2px solid rgb(230 109 51)', paddingBottom: '6px' }}>
                                                        Menu Items
                                                    </h5>
                                                    {Object.entries(order.items).map(([category, items]) => {
                                                        if (!Array.isArray(items)) return null;
                                                        return (
                                                            <div key={category} style={{ marginBottom: '12px' }}>
                                                                <div style={{ fontSize: '13px', fontWeight: '600', color: '#4a5568', marginBottom: '6px' }}>
                                                                    {category} ({items.length})
                                                                </div>
                                                                {items.map((item, index) => {
                                                                    const nonVeg = isNonVeg(item);
                                                                    return (
                                                                        <div key={index} style={{ ...styles.menuItem, ...(nonVeg ? styles.menuItemNonVeg : styles.menuItemVeg) }}>
                                                                            <span>{item}</span>
                                                                            <span style={{ ...styles.badge, ...(nonVeg ? styles.nonVegBadge : styles.vegBadge) }}>
                                                                                {nonVeg ? 'Non-Veg' : 'Veg'}
                                                                            </span>
                                                                        </div>
                                                                    );
                                                                })}
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            )}

                                            {/* Add-Ons */}
                                            {order.addOns && Array.isArray(order.addOns) && order.addOns.some(a => a.selected) && (
                                                <div style={{ marginBottom: '16px' }}>
                                                    <h5 style={{ color: 'rgb(230 109 51)', marginBottom: '10px', fontSize: '15px', fontWeight: '600', borderBottom: '2px solid rgb(230 109 51)', paddingBottom: '6px' }}>
                                                        Add-Ons
                                                    </h5>
                                                    {order.addOns.filter(a => a.selected).map((addon, index) => (
                                                        <div key={index} style={styles.addOnItem}>
                                                            <span>{formatAddOnName(addon.addOnType)}</span>
                                                            <span style={{ background: '#48bb78', color: 'white', padding: '2px 10px', borderRadius: '20px', fontSize: '12px', fontWeight: '600' }}>
                                                                Qty: {addon.quantity}
                                                            </span>
                                                        </div>
                                                    ))}
                                                </div>
                                            )}

                                            {/* Additional Requests */}
                                            {order.additionalRequests && (
                                                <div style={{ background: '#fefcbf', padding: '12px 16px', borderRadius: '8px', marginBottom: '16px', border: '1px solid #f6e05e' }}>
                                                    <span style={{ fontWeight: '600' }}>📝 Additional Requests: </span>
                                                    <span>{order.additionalRequests}</span>
                                                </div>
                                            )}

                                            {/* Payment Section */}
                                            <div style={{ background: '#f7fafc', padding: '16px', borderRadius: '8px', marginBottom: '16px', border: '1px solid #edf2f7' }}>
                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '16px' }}>
                                                    <div>
                                                        <div style={{ fontSize: '12px', color: '#718096', fontWeight: '500' }}>Budget</div>
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '4px' }}>
                                                            <span style={{ fontWeight: '700' }}>₹</span>
                                                            {isEditing ? (
                                                                <input
                                                                    type="text"
                                                                    value={currentAmounts.budget}
                                                                    onChange={(e) => handleAmountChange(orderId, 'budget', e.target.value)}
                                                                    style={{ ...styles.budgetInput, width: '120px' }}
                                                                />
                                                            ) : (
                                                                <span style={{ fontSize: '18px', fontWeight: '700' }}>{currentAmounts.budget || '0'}</span>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <div style={{ fontSize: '12px', color: '#718096', fontWeight: '500' }}>Including Lead Price</div>
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '4px' }}>
                                                            <span style={{ fontWeight: '700' }}>₹</span>
                                                            {isEditing ? (
                                                                <input
                                                                    type="text"
                                                                    value={currentAmounts.paymentAmount}
                                                                    onChange={(e) => handleAmountChange(orderId, 'paymentAmount', e.target.value)}
                                                                    style={{ ...styles.budgetInput, width: '120px', borderColor: 'rgb(230 109 51)' }}
                                                                />
                                                            ) : (
                                                                <span style={{ fontSize: '18px', fontWeight: '700', color: 'rgb(230 109 51)' }}>{currentAmounts.paymentAmount || '0'}</span>
                                                            )}
                                                        </div>
                                                    </div>
                                                    {isEditing && (
                                                        <button onClick={() => handleCancelEdit(orderId)} style={{ ...styles.button, ...styles.buttonCancel }}>
                                                            <Icons.Cancel /> Cancel
                                                        </button>
                                                    )}
                                                </div>
                                            </div>

                                            {/* Vendor Selection */}
                                            <OrderVendorSelection
                                                vendors={vendors}
                                                order={order}
                                                onSendApproval={handleSendApproval}
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>
                        );
                    })
                )}
            </div>

            <style>{`
                @keyframes slideInRight {
                    from { opacity: 0; transform: translateX(100%); }
                    to { opacity: 1; transform: translateX(0); }
                }
                @keyframes fadeOut {
                    from { opacity: 1; }
                    to { opacity: 0; }
                }
                div::-webkit-scrollbar { width: 6px; height: 6px; }
                div::-webkit-scrollbar-track { background: #f1f1f1; border-radius: 4px; }
                div::-webkit-scrollbar-thumb { background: #c1c1c1; border-radius: 4px; }
                div::-webkit-scrollbar-thumb:hover { background: #a1a1a1; }
            `}</style>
        </div>
    );
};

// Vendor Selection Component
const OrderVendorSelection = ({ vendors, order, onSendApproval }) => {
    const [selectedVendors, setSelectedVendors] = useState([]);
    const [showDropdown, setShowDropdown] = useState(false);
    const [showSuccessPopup, setShowSuccessPopup] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [searchTerm, setSearchTerm] = useState("");
    const [isApproved, setIsApproved] = useState(false);

    useEffect(() => {
        if (showSuccessPopup) {
            const timer = setTimeout(() => {
                setShowSuccessPopup(false);
                setSuccessMessage("");
            }, 2000);
            return () => clearTimeout(timer);
        }
    }, [showSuccessPopup]);

    const handleSelectVendor = (vendorId) => {
        if (isApproved) return;
        setSelectedVendors(prev => prev.includes(vendorId) ? prev.filter(id => id !== vendorId) : [...prev, vendorId]);
    };

    const handleSelectAll = () => {
        if (isApproved) return;
        const filteredIds = filteredVendors.map(v => v.id);
        setSelectedVendors(prev => {
            const allSelected = filteredIds.every(id => prev.includes(id));
            if (allSelected) {
                return prev.filter(id => !filteredIds.includes(id));
            } else {
                return [...new Set([...prev, ...filteredIds])];
            }
        });
    };

    const filteredVendors = (vendors || []).filter(vendor => vendor.companyName?.toLowerCase().includes(searchTerm.toLowerCase()));

    const handleSendToAllVendors = () => {
        if (isApproved) return;
        onSendApproval(order, [], true);
        setShowDropdown(false);
        setSelectedVendors([]);
        setIsApproved(true);
    };

    const handleApprove = () => {
        if (isApproved) return;
        if (selectedVendors.length === 0) {
            setSuccessMessage("❌ Please select at least one vendor");
            setShowSuccessPopup(true);
            return;
        }
        onSendApproval(order, selectedVendors, false);
        setShowDropdown(false);
        setIsApproved(true);
    };

    return (
        <div style={{ marginTop: '16px', paddingTop: '16px', borderTop: '2px solid #edf2f7' }}>
            {showSuccessPopup && (
                <div style={{
                    position: 'fixed',
                    top: '20px',
                    right: '20px',
                    padding: '12px 20px',
                    borderRadius: '8px',
                    background: successMessage.includes('❌') ? '#fc8181' : '#48bb78',
                    color: 'white',
                    zIndex: 9999,
                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                    animation: 'slideInRight 0.3s ease, fadeOut 0.3s ease 1.7s'
                }}>
                    {successMessage}
                </div>
            )}

            <h4 style={{ textAlign: 'center', color: '#2d3748', marginBottom: '12px', fontSize: '15px', fontWeight: '600' }}>
                <Icons.Vendor /> Select Vendors for Assignment
            </h4>

            {isApproved ? (
                <div style={styles.approvedBadge}>
                    <Icons.Approved /> Approved
                </div>
            ) : (
                <div style={styles.actionButtons}>
                    <button onClick={handleSendToAllVendors} style={{ ...styles.button, ...styles.buttonSuccess }}>
                        <Icons.Check /> All Vendors
                    </button>
                    <button onClick={() => setShowDropdown(!showDropdown)} style={{ ...styles.button, ...styles.buttonSecondary }}>
                        {showDropdown ? 'Hide Vendors' : 'Select Vendors'} {selectedVendors.length > 0 ? `(${selectedVendors.length})` : ''}
                    </button>
                </div>
            )}

            {showDropdown && !isApproved && (
                <div style={styles.vendorDropdown}>
                    <div style={{ padding: '12px 16px', borderBottom: '1px solid #edf2f7', background: '#f7fafc' }}>
                        <input
                            type="text"
                            placeholder="Search by company name..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            style={{ width: '100%', padding: '8px 12px', border: '1px solid #e2e8f0', borderRadius: '6px', fontSize: '13px', outline: 'none' }}
                        />
                        <div style={{ marginTop: '8px', display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }} onClick={handleSelectAll}>
                            <input type="checkbox" checked={filteredVendors.length > 0 && selectedVendors.length === filteredVendors.length} onChange={handleSelectAll} onClick={(e) => e.stopPropagation()} />
                            <span style={{ fontSize: '13px', fontWeight: '500' }}>Select All ({filteredVendors.length})</span>
                            <span style={{ marginLeft: 'auto', fontSize: '12px', color: '#718096' }}>{selectedVendors.length} selected</span>
                        </div>
                    </div>

                    <div style={{ maxHeight: '250px', overflowY: 'auto' }}>
                        {filteredVendors.length > 0 ? (
                            filteredVendors.map(vendor => (
                                <div
                                    key={vendor.id}
                                    style={{
                                        ...styles.vendorItem,
                                        ...(selectedVendors.includes(vendor.id) ? styles.vendorItemSelected : {})
                                    }}
                                    onClick={() => handleSelectVendor(vendor.id)}
                                >
                                    <input
                                        type="checkbox"
                                        checked={selectedVendors.includes(vendor.id)}
                                        onChange={() => handleSelectVendor(vendor.id)}
                                        onClick={(e) => e.stopPropagation()}
                                    />
                                    <span style={styles.vendorName}>{vendor.companyName}</span>
                                </div>
                            ))
                        ) : (
                            <div style={{ padding: '20px', textAlign: 'center', color: '#718096' }}>
                                No vendors found matching "{searchTerm}"
                            </div>
                        )}
                    </div>

                    <div style={{ padding: '12px 16px', borderTop: '1px solid #edf2f7', background: '#f7fafc', fontSize: '12px', color: '#718096', display: 'flex', justifyContent: 'space-between' }}>
                        <span>{selectedVendors.length} vendor{selectedVendors.length !== 1 ? 's' : ''} selected</span>
                        <span>Total: {vendors.length} vendors</span>
                    </div>
                </div>
            )}

            {!isApproved && (
                <button onClick={handleApprove} style={{ ...styles.button, ...styles.buttonPrimary, width: '100%', marginTop: '12px', justifyContent: 'center', fontSize: '16px', padding: '12px' }}>
                    <Icons.Check /> Approve Order
                </button>
            )}
        </div>
    );
};

export default Vendordersdetails;









